//Order is desc, asc. Can be extended and replaced on [1, -1, 0] (desc, ask, no sorting) if it will be the case when need to support reset sorting.
export const SORTING_ORDER = [1, -1];
